var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'thumb-130')?_c('img',{staticClass:"lazyload lazyfade",class:{
    lazyload: !!_vm.reloadImage,
  },attrs:{"data-src":`${_vm.defaultImgPrefix}/130/130-${_vm.image}`,"data-srcset":_vm.defaultImgPrefix +
    '/130/130-' +
    _vm.image +
    ' 1x, ' +
    _vm.defaultImgPrefix +
    '/320/320-' +
    _vm.image +
    ' 2x ',"alt":_vm.title}}):(_vm.type === 'thumb-320' && _vm.image)?_c('img',{staticClass:"lazyload lazyfade",class:{
    lazyload: !!_vm.reloadImage,
  },attrs:{"data-src":`${_vm.defaultImgPrefix}/320/320-${_vm.image}`,"data-srcset":`${_vm.defaultImgPrefix}/320/320-${_vm.image} 1x,
    ${_vm.defaultImgPrefix}/640/640-${_vm.image} 2x`,"width":"320","height":"120","alt":_vm.title}}):(_vm.type === 'thumb-320' && !_vm.image)?_c('img',{attrs:{"src":"/assets/img/placeholder.svg","width":"100%","alt":"Content is not live placeholder image"}}):(_vm.type === 'browser-select-max-800')?_c('img',{staticClass:"lazyload lazyfade",class:{
    lazyload: !!_vm.reloadImage,
  },attrs:{"data-src":`${_vm.defaultImgPrefix}/320/320-${_vm.image}`,"data-srcset":_vm.defaultImgPrefix +
    '/800/800-' +
    _vm.image +
    ' 800w, ' +
    _vm.defaultImgPrefix +
    '/640/640-' +
    _vm.image +
    ' 640w, ' +
    _vm.defaultImgPrefix +
    '/320/320-' +
    _vm.image +
    ' 320w ',"alt":_vm.title}}):(_vm.type === 'card-640')?_c('img',{staticClass:"lazyload lazyfade",class:{
    lazyload: !!_vm.reloadImage,
  },attrs:{"data-src":`${_vm.defaultImgPrefix}/640/640-${_vm.image}`,"alt":_vm.title}}):(_vm.type === 'unit-image')?_c('picture',{staticClass:"unit-image"},[_c('source',{attrs:{"type":"image/webp","data-srcset":_vm.defaultImgPrefix +
      '/1440/1440-' +
      _vm.imageWithWebpExt +
      ' 1440w, ' +
      _vm.defaultImgPrefix +
      '/720/720-' +
      _vm.imageWithWebpExt +
      ' 720w, ',"sizes":_vm.sizes ? _vm.sizes : '(max-width: 940px) 100vw, 50vw'}}),_vm._v(" "),_c('source',{attrs:{"type":"image/png","data-srcset":_vm.defaultImgPrefix +
      '/1440/1440-' +
      _vm.image +
      ' 1440w, ' +
      _vm.defaultImgPrefix +
      '/720/720-' +
      _vm.image +
      ' 720w, ',"sizes":_vm.sizes ? _vm.sizes : '(max-width: 940px) 100vw, 50vw'}}),_vm._v(" "),_c('img',{staticClass:"lazyload lazyfade",class:{
      lazyload: !!_vm.reloadImage,
    },attrs:{"data-src":_vm.defaultImgPrefix + '/1440/1440-' + _vm.image,"src":_vm.defaultImgPrefix + '/1440/1440-' + _vm.image,"alt":"","width":"720","height":"360"}})]):(_vm.type === 'unit-image-2880')?_c('picture',{staticClass:"unit-image"},[_c('source',{attrs:{"type":"image/webp","data-srcset":_vm.defaultImgPrefix +
      '/2880/2880-' +
      _vm.imageWithWebpExt +
      ' 2880, ' +
      _vm.defaultImgPrefix +
      '/2160/2160-' +
      _vm.imageWithWebpExt +
      ' 2160w, ' +
      _vm.defaultImgPrefix +
      '/1440/1440-' +
      _vm.image +
      ' 1440w, ' +
      _vm.defaultImgPrefix +
      '/720/720-' +
      _vm.image +
      ' 720w, ',"sizes":_vm.sizes ? _vm.sizes : '(max-width: 940px) 100vw, 50vw'}}),_vm._v(" "),_c('source',{attrs:{"type":"image/png","data-srcset":_vm.defaultImgPrefix +
      '/2880/2880-' +
      _vm.image +
      ' 2880, ' +
      _vm.defaultImgPrefix +
      '/2160/2160-' +
      _vm.image +
      ' 2160w, ' +
      _vm.defaultImgPrefix +
      '/1440/1440-' +
      _vm.image +
      ' 1440w, ' +
      _vm.defaultImgPrefix +
      '/720/720-' +
      _vm.image +
      ' 720w, ',"sizes":_vm.sizes ? _vm.sizes : '(max-width: 940px) 100vw, 50vw'}}),_vm._v(" "),_c('img',{staticClass:"lazyload lazyfade",class:{
      lazyload: !!_vm.reloadImage,
    },attrs:{"data-src":_vm.defaultImgPrefix + '/1440/1440-' + _vm.image,"src":_vm.defaultImgPrefix + '/1440/1440-' + _vm.image,"alt":"","width":"720","height":"360"}})]):_c('img',{staticClass:"lazyload lazyfade",class:{
    lazyload: !!_vm.reloadImage,
  },attrs:{"data-src":`${_vm.defaultImgPrefix}/320/320-${_vm.image}`,"data-srcset":_vm.defaultImgPrefix +
    '/1020/1020-' +
    _vm.image +
    ' 1020w, ' +
    _vm.defaultImgPrefix +
    '/800/800-' +
    _vm.image +
    ' 800w, ' +
    _vm.defaultImgPrefix +
    '/640/640-' +
    _vm.image +
    ' 640w, ' +
    _vm.defaultImgPrefix +
    '/320/320-' +
    _vm.image +
    ' 320w ',"sizes":"\n    (min-width: 941px) 320px,\n    (min-width: 601px) and (max-width: 940px) calc(50vw - 18px),\n    (max-width: 600px) 100vw calc(100vw - 12px)\n  ","alt":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }